@switch (step) {
  @case (Step.Environment) {
    <ng-closet-doors-standard-environment
      [emplacements]="closetDoorsService.emplacements"
      [hasDrawers]="current.closetDoors.hasDrawers"
      [drawersLocation]="current.closetDoors.drawersLocation"
      [selectedEmplacement]="current.closetDoors.selectedEmplacement"
      (onEmplacementSelect)="selectEmplacement($event)"
      (onHasDrawersSelect)="selectHasDrawers($event)"
      (onDrawersLocationSelect)="selectDrawersLocation($event)">
    </ng-closet-doors-standard-environment>
  }

  @case (Step.DoorConfiguration) {
    <ng-closet-doors-standard-door-configuration></ng-closet-doors-standard-door-configuration>
  }

  @case (Step.Range) {
    <ng-closet-doors-standard-range
      [configId]="current.closetDoors.id"
      [selectedRange]="current.closetDoors.range"
      (onRangeSelect)="selectRange($event)">
    </ng-closet-doors-standard-range>
  }

  @case (Step.Finishes) {
    <ng-closet-doors-standard-finishes
      (onSubStepChange)="getFinishesSubStep($event)">
    </ng-closet-doors-standard-finishes>
  }

  @case (Step.Summary) {
    <ng-closet-doors-standard-summary
      [resume]="current.closetDoors.resume">
    </ng-closet-doors-standard-summary>
  }
}
